import styled from 'styled-components';
import { CategoryButtonList } from 'styles/Page.styles';
import { Category } from 'components/CategoryFilter/CategoryFilter.styles';
import {
  Heading,
  HeadingProps
} from '@trustedshops/tps-seo-shared-frontend-react-components';

export const KeywordList = styled.div`
  ${CategoryButtonList}

  ${Category} {
    margin-bottom: 48px;
  }
`;

export const KeywordListHeading = styled(Heading)<HeadingProps>`
  margin-top: 56px;
  margin-bottom: 23px;
  text-align: center;
`;
